import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Waypoint from "react-waypoint";

import isEmpty from "lodash/isEmpty";

import VirtualGiftListItem from "./VirtualGiftItem";
import {getMemberVirtualGifts} from 'reducers/memberVirtualGifts';

import 'sass/list/VirtualGiftList.scss';

class VirtualGiftList extends Component {
    static fetchData ({getMemberVirtualGifts, offset}) {
        getMemberVirtualGifts(offset);
    }
    
    loadMaterials = () => {
        const {getMemberVirtualGifts, memberVirtualGifts: {offset, isLoading}} = this.props;
        if (!isLoading) {
            this.constructor.fetchData({getMemberVirtualGifts, offset});
        }
    };
    
    componentDidMount() {
        const {memberVirtualGifts: {virtualGifts}, virtualGifts: propsVirtualGifts} = this.props;

        if (!propsVirtualGifts && isEmpty(virtualGifts)) {
            this.loadMaterials();
        }
    }
    
    onWayPointEnter = () => {
        const { memberVirtualGifts: { totalCount, isLoading, offset }} = this.props;
        if (!isLoading && offset < totalCount) {
            this.loadMaterials();
        }
    };
    
    render() {
        const {memberVirtualGifts: {virtualGifts}, virtualGifts: propsVirtualGifts, singleRow = false, ...restProps} = this.props;

        const list = propsVirtualGifts ? propsVirtualGifts : virtualGifts;

        return (
            <div className={'virtual-gift-list ui-responsive-grid' + (singleRow ? ' single-row': '')}>
                {list.map((virtualGift, index) =>
                    <div key={index}>
                        <VirtualGiftListItem virtualGift={virtualGift} {...restProps}/>
                    </div>
                )}
                {!propsVirtualGifts ? <Waypoint onEnter={this.onWayPointEnter} /> : null}
            </div>
        )
    }
}

VirtualGiftList.propTypes = {
    singleRow: PropTypes.bool,
    actions: PropTypes.bool,
    openFn: PropTypes.func,
    showDetails: PropTypes.bool,
    memberVirtualGifts: PropTypes.object.isRequired,
    getMemberVirtualGifts: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    memberVirtualGifts: state.memberVirtualGifts
});

const mapDispatchToProps = {
    getMemberVirtualGifts
};

export default connect(mapStateToProps, mapDispatchToProps)(VirtualGiftList);


// WEBPACK FOOTER //
// ./src/components/virtualgift/VirtualGiftList.js